import { ActionReducerMap } from '@ngrx/store';
import * as fromMasterAppDB from './app-master-db/app-master-db.reducer';
// import * as fromWorkItemsDB from './work-items-db/work-items-db.reducer';
import * as fromShiftsDB from './shifts/shifts.reducer';
import * as fromMasterDB from './master-data-db/master-data-db.reducer';
import * as fromMetadata from './metadata/metadata.reducer';
// import * as fromEventsDB from './events-db/events-db.reducer';

export interface TInputAppState {
  appMasterDB: fromMasterAppDB.TAppMasterDatabase;
  // workItemsDB: fromWorkItemsDB.TWorkItemsDatabases;
  shifts: fromShiftsDB.IShiftsState;
  masterDataDB: fromMasterDB.TMasterDataDatabases;
  metadataDB: fromMetadata.TInputAppMetadata;
  // eventsDB: fromEventsDB.TEventsDatabase;
}

export const inputAppReducer: ActionReducerMap<TInputAppState> = {
  appMasterDB: fromMasterAppDB.appMasterDBReducer as any,
  // workItemsDB: fromWorkItemsDB.workItemsDBReducer as any,
  shifts: fromShiftsDB.shiftsReducer as any,
  masterDataDB: fromMasterDB.masterDataReducer as any,
  metadataDB: fromMetadata.InputAppMetadataStateReducer as any,
  // eventsDB: fromEventsDB.eventsDBReducer as any,
};
